<template>
    <v-form ref="form" @submit.prevent>
        <v-layout class="password-creation" row wrap>
            <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Anrede*' | translation }}</p>
            <v-flex xs12 py-0>
                <v-select
                    v-model="salutation"
                    :items="salutations"
                    :rules="[rules.required]"
                    :label="inputLabelOutside ? '' : $language.translate('Anrede*')"
                    required
                    :disabled="disabled"
                    class="pt-0"
                />
            </v-flex>

            <v-flex xs12 py-0>
                <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Vorname*' | translation }}</p>
                <v-text-field
                    v-model="firstName"
                    :rules="[rules.required, rules.firstName]"
                    :label="inputLabelOutside ? '' : $language.translate('Vorname*')"
                    required
                    :disabled="disabled"
                    class="pt-0"
                />
            </v-flex>

            <v-flex xs12 py-0>
                <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Nachname*' | translation }}</p>
                <v-text-field
                    v-model="lastName"
                    :rules="[rules.required]"
                    :label="inputLabelOutside ? '' : $language.translate('Nachname*')"
                    required
                    :disabled="disabled"
                    class="pt-0"
                />
            </v-flex>

            <v-flex xs12 py-0>
                <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Fiscal code*' | translation }}</p>
                <v-text-field
                    v-model="fiscalCode"
                    :label="inputLabelOutside ? '' : $language.translate('Fiscal code*')"
                    :disabled="disabled"
                    class="pt-0"
                />
            </v-flex>

            <v-flex xs12 py-0 v-if="!isUserLoggedIn">
                <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Email*' | translation }}</p>
                <v-text-field
                    v-model="email"
                    :rules="[rules.required, rules.email]"
                    :label="inputLabelOutside ? '' : $language.translate('Email*')"
                    required
                    :error-messages="errors['email']"
                    @change="resetErrors('email')"
                    :disabled="disabled"
                    class="pt-0"
                />
            </v-flex>

            <v-flex xs12 v-if="!isUserLoggedIn && askPassword" py-0>
                <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Passwort*' | translation }}</p>
                <v-text-field
                    v-model="password"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    :rules="[rules.required, rules.length]"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    :label="inputLabelOutside ? '' : $language.translate('Passwort*')"
                    required
                    browser-autocomplete="new-password"
                    :error-messages="errors['password']"
                    @change="resetErrors('password')"
                    :disabled="disabled"
                    class="pt-0"
                />
            </v-flex>
        </v-layout>
    </v-form>
</template>

<script>
    import {createNamespacedHelpers} from 'vuex';
    import Registration from '../default/Registration';

    const moduleName = 'Registration';
    const {mapState, mapGetters, mapMutations} = createNamespacedHelpers(moduleName);

    export default {
        extends: Registration,
        computed: {
            fiscalCode: {
                get() {
                    return this.getFiscalCode();
                },
                set(value) {
                    this.setFiscalCode(value);
                },
            },
        },
        methods: {
            ...mapGetters([
                'getFiscalCode',
            ]),
            ...mapMutations([
                'setFiscalCode',
            ]),
        }
    };
</script>
